import type { PageCard } from '@/play/pageTypes'
import { SlimeFamilyCardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'slime-family',
  number: 31,
  title: 'Slime family',
  question: 'Does making slime creatures (a press makes a gob, a tap on a gob gives it eyes) and changing the light on them feel magical?',
  status: 'open',
  accent: '#ffd0e8',
  CardArt: SlimeFamilyCardArt,
}
